/* aurapik quick-add — adds a variant to cart and refreshes Dawn's cart drawer */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  const id = btn.getAttribute('data-quick-add');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  btn.classList.add('is-loading');
  btn.disabled = true;
  try {
    const drawer = document.querySelector('cart-drawer');
    const sectionIds =
      drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
    const body = { items: [{ id: Number(id), quantity: 1 }] };
    if (sectionIds.length) {
      body.sections = sectionIds;
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw data;
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents(data);
      if (typeof drawer.open === 'function') drawer.open(btn);
    } else {
      document.dispatchEvent(new CustomEvent('aurapik:added', { detail: data }));
      window.location.href = `${root}cart`;
    }
  } catch (err) {
    console.error('aurapik quick-add failed', err);
  } finally {
    btn.classList.remove('is-loading');
    btn.disabled = false;
  }
});
